module.exports = __webpack_public_path__ + "img/w3_chevron_left_light.d324fb6f.png";